export default "__VITE_ASSET__3DMb1WoQ__"